<template>
  <div
    class="faq-card"
    :class="{ 'faq-card--open': item._.open }"
    @click="$emit('toggle')"
  >
    <div class="faq-card__question">
      {{ item.question }}
    </div>
    <div
      class="faq-card__answer"
      :class="{ 'faq-card__answer--open': item._.open }"
    >
      {{ item.answer }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
